export const SEARCH_DIALOG_WIDTH_OBSERVER_ID = 'quick-find-dialog';

export const QUICK_FIND_OPEN_INTERACTION = 'quick-find-open';
export const QUICK_FIND_CLOSE_INTERACTION = 'quick-find-close';
export const QUICK_FIND_POST_QUERY_INTERACTION = 'quick-find-post-query';
export const QUICK_FIND_LOADING_HOLD = 'quick-find-loading';
